import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', _ => {
    document.querySelectorAll('.column-carousel').forEach(carousel => {
        const slider = new Swiper(carousel, {
            modules: [Navigation, Scrollbar],
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            initialSlide: 0,
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: 26,
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            breakpoints: {
                521: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 4,
                },
            },
        });
    });
});
